import { z } from "zod"

import { WorkspaceUserRole } from "@/features/users/model"

type SchemaMessages = {
  emailRequired: string
  emailInvalid: string
  roleRequired: string
}

export type UserInviteFormInput = {
  email: string
  role: WorkspaceUserRole
}

export const defaultUserInviteFormValues: UserInviteFormInput = {
  email: "",
  role: WorkspaceUserRole.USER,
}

export function createUserInviteFormSchema(messages: SchemaMessages) {
  return z.object({
    email: z
      .string()
      .trim()
      .min(1, messages.emailRequired)
      .email(messages.emailInvalid),
    role: z.nativeEnum(WorkspaceUserRole, {
      message: messages.roleRequired,
    }),
  })
}
